import React, { useState, useEffect } from 'react'
import { useDispatch } from '@/store'
import { useUrlSearch } from '@/hooks'
import { useHistory } from 'react-router'
import { useMount } from 'ahooks'
import { loginWithTicketApi } from '@/services/api'
import { changeLanguage } from '@/store/languageSlice'
import { LANGUAGE } from '@/constants'
import { checkLogin, getAuthSource, getUserInfo } from '@/store/authSlice'
import { PageLoading } from '@/components/Loading'
import { deleteUrlQuery } from '@/utils'
import i18n from 'i18next'
import { getWarehoseInfo, getSellerOwnerType } from '@/store/commonSlice'
import Cookies from 'js-cookie'
import { getConfig } from '@/store/configSlice'

const withCheckLogin = (Component) => {
  return function CheckAuthorize(props) {
    const { ticket, lang } = useUrlSearch()
    const dispatch = useDispatch()

    const history = useHistory()
    const [isReady, setIsReady] = useState(false)

    const toLoginPage = (noSearch?: boolean) => {
      Cookies.remove('authorization')
      let oneclubUrl = `${process.env.ONECLUB_URL}/user/login?app=ow&lang=${i18n.language}&service=${encodeURIComponent(window.location.href)}`
      if (noSearch) {
        oneclubUrl = `${process.env.ONECLUB_URL}/user/login?app=ow&lang=${i18n.language}`
      }
      location.href = oneclubUrl
    }

    const initUserInfo = async () => {
      const [warehouseInfo] = await Promise.all([dispatch(getWarehoseInfo()), dispatch(getUserInfo()), dispatch(getAuthSource()), dispatch(getConfig)])
      if (warehouseInfo?.data?.length === 0) {
        history.push('/noAuth')
        return
      }

      dispatch(getSellerOwnerType()) // 获取商家类型：统一货主、多货主
    }

    useMount(async () => {
      setIsReady(false)
      const { isLogined } = await dispatch(checkLogin())
      if (lang) {
        const _lang = (lang === 'zh' && 'zh-CN') || lang
        await i18n.changeLanguage(_lang)
        dispatch(changeLanguage(LANGUAGE.find((i) => i.lang === _lang)))
      }
      if (!isLogined || ticket) {
        // ticket存在就是oneclub那边登录成功了，这里拿ticket去调登录接口
        if (ticket) {
          try {
            const res = await loginWithTicketApi({ ticket, appid: process.env.APPID, subappid: process.env.SUB_APPID }).catch((err) => {
              // ticket无效等错误，回到登录页
              toLoginPage(true)
              return err
            })

            if (res?.rescode === '0') {
              window.history.replaceState(null, null, location.pathname)

              await dispatch(checkLogin())

              await initUserInfo()

              setIsReady(true)
            }
          } catch (err) {
            if (err === 'LST-133242-G0001') {
              window.location.replace('/noAuth')
              return
            }

            // eslint-disable-next-line no-console
            console.error(err)
            if (navigator.onLine) {
              // 网络状况没问题，刷新重试
              setTimeout(() => {
                location.reload()
              }, 5000)
            } else {
              // 网络有问题，当重新在线时刷新页面
              window.addEventListener('online', () => {
                location.reload()
              })
            }
          }
        } else {
          toLoginPage()
        }
        return
      }

      await initUserInfo()

      setIsReady(true)
    })

    useEffect(() => {
      if (isReady) {
        deleteUrlQuery(['lang', 'ticket', 'adminTicket'])
      }
    }, [isReady])

    return isReady ? <Component {...props} /> : <PageLoading />
  }
}
export default withCheckLogin
